import React from "react";
import "./detailThree.scss"
import initMeg from "../../assets/productions/init-meg.png"
import initEeg from "../../assets/productions/init-eeg.png"
import jtBlue from "../../assets/jtBlue.png";
import hbcloudv3 from "../../assets/productions/hbcloudv3.png";
import waveimg from "../../assets/productions/waveimg.png";
import step1 from "../../assets/productions/step-1-img.png";
import step21 from "../../assets/productions/step-2-img1.png"
import step22 from "../../assets/productions/step-2-img2.png"
import step23 from "../../assets/productions/step-2-img3.png"
import step24 from "../../assets/productions/step-2-img4.png"
import machineCube from "../../assets/productions/machine-cube.png"

class DetailThree extends React.Component {
    render() {
        
        return <div className="detail-3">
            <div className="detail-3-title">
                <div className="title-txt">
                    <p>NeuroSignal<sup>TM</sup>系统</p>
                    <p>“一站式”解决方案</p>
                </div>
            </div>
            <div className="section-1">
                <img src={initMeg} className="meg" />
                <div className="desc">
                    <p>脑磁图/脑电图</p>
                    <p>原始数据</p>
                </div>
                <img src={initEeg} className="eeg" />
            </div>
            <div className="next-section">
                <div className="line left"></div>
                <img src={jtBlue} />
                <div className="line right"></div>
            </div>
            <div className="section-2">
                <div className="product-advantage">
                    <div className="item">
                        <div className="title">
                            <span className="title-txt">灵活数据集管理</span>
                            <div className="back-circle"></div>
                        </div>
                        <img src={hbcloudv3} />
                    </div>
                    <img src={jtBlue} className="next-part"/>
                    <div className="item">
                        <div className="title">
                            <span className="title-txt">快速高效数据质控</span>
                            <div className="back-circle"></div>
                        </div>
                        <img src={waveimg} />
                    </div>
                </div>
                <div className="product-flow">
                    <div className="step">
                        <div className="title">
                            <div className="back-ground">
                                <span className="line" style={{ left: 0 }}></span>
                                <span className="circle"></span>
                                <span className="line" style={{ right: 0 }}></span>
                                <span className="title-txt">“一键式”完成复杂预处理</span>
                            </div>
                            <img src={step1} className="step-img" />
                        </div>
                    </div>
                    <img src={jtBlue} className="next-flow"/>
                    <div className="step">
                        <div className="title">
                            <div className="back-ground">
                                <span className="line" style={{ left: 0 }}></span>
                                <span className="circle"></span>
                                <span className="line" style={{ right: 0 }}></span>
                                <span className="title-txt">“一键式”脑电图数据分析</span>
                            </div>
                            <div className="step-demo">
                                <ul>
                                    <li className="item">
                                        <img src={step21} alt="" />
                                        <div className="img-desc">事件相关电位分析</div>
                                    </li>
                                    <li className="item">
                                        <img src={step22} alt="" />
                                        <div className="img-desc">电场分布分析</div>
                                    </li>
                                    <li className="item">
                                        <img src={step23} alt="" />
                                        <div className="img-desc">复杂脑网络分析</div>
                                    </li>
                                    <li className="item">
                                        <img src={step24} alt="" />
                                        <div className="img-desc">事件相关电位分析</div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="private-system">
                    <div className="title">
                        <div className="line" style={{ left: 0 }}></div>
                        <div className="line" style={{ right: 0 }}></div>
                        <div className="title-txt">私有化部署的NeuroSignal<sup>TM</sup>系统</div>
                    </div>
                    <div className="system-desc">
                        <div className="item">
                            <div className="title">
                                NeuroSignal<sup>TM</sup>计算能力
                            </div>
                            <div className="list">
                                <ul>
                                    <li>700以上逻辑核计算核心</li>
                                    <li>分布式数据备份</li>
                                    <li>搭载高性能计算显卡</li>
                                </ul>
                                <ul>
                                    <li>100TB以上有效存储</li>
                                    <li>2TB以上内存</li>
                                    <li>千兆/万兆网络</li>
                                </ul>
                            </div>
                        </div>
                        <img src={machineCube} className="system-machine"/>
                        <div className="item">
                            <div className="title">
                                机房需求
                            </div>
                            <div className="list">
                                <ul>
                                    <li>配备双路电源</li>
                                    <li>24小时制冷系统</li>
                                    <li>接入内部网络</li>
                                </ul>
                                <ul>
                                    <li>额定功率≧22KW</li>
                                    <li>额定电流≧100A</li>
                                    <li>电源电压=220V</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
}
export default DetailThree;